import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

const getComplaintsSummary = async (filters = {}) => {
  const response = await axios.get(`${API_URL}/api/analytics/widgets/complaints.summary`, {
    headers: authHeaders(),
    params: filters
  });
  return response.data;
};

const getWidgetConfig = async (widgetKey) => {
  const res = await axios.get(`${API_URL}/api/analytics/widgets/config/${widgetKey}`, { headers: authHeaders() });
  return res.data;
};

const saveWidgetConfig = async (widgetKey, config) => {
  const res = await axios.put(`${API_URL}/api/analytics/widgets/config/${widgetKey}`, { config }, { headers: authHeaders() });
  return res.data;
};

const getProductionSummary = async (filters = {}) => {
  const response = await axios.get(`${API_URL}/api/analytics/widgets/production.summary`, {
    headers: authHeaders(),
    params: filters
  });
  return response.data;
};

const getEnvironmentalSummary = async (filters = {}) => {
  const response = await axios.get(`${API_URL}/api/analytics/widgets/environmental.summary`, {
    headers: authHeaders(),
    params: filters
  });
  return response.data;
};

const getIngredientsSummary = async (filters = {}) => {
  const response = await axios.get(`${API_URL}/api/analytics/widgets/ingredients.summary`, {
    headers: authHeaders(),
    params: filters,
  });
  return response.data;
};

const getSalesSummary = async (filters = {}) => {
  const response = await axios.get(`${API_URL}/api/analytics/widgets/sales.summary`, {
    headers: authHeaders(),
    params: filters,
  });
  return response.data;
};

const getSalesByCustomer = async (filters = {}) => {
  const response = await axios.get(`${API_URL}/api/analytics/widgets/sales.by-customer`, {
    headers: authHeaders(),
    params: filters,
  });
  return response.data;
};

const askSalesAi = async (question, history = []) => {
  const response = await axios.post(`${API_URL}/api/analytics/widgets/sales.ask`, { question, history }, {
    headers: authHeaders(),
  });
  return response.data;
};

const analyticsService = {
  getComplaintsSummary,
  getProductionSummary,
  getEnvironmentalSummary,
  getIngredientsSummary,
  getSalesSummary,
  getSalesByCustomer,
  askSalesAi,
  getWidgetConfig,
  saveWidgetConfig,
};

export default analyticsService;